exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-15014480] {\r\n    padding: 3em 2em;\n}\n.notifications-list .list-group-item[data-v-15014480] {\r\n    cursor: pointer;\n}\n.notifications-list .list-group-item[data-v-15014480]:hover {\r\n    background: #eee;\n}\n.notifications-list .list-group-item.unread[data-v-15014480] {\r\n    background: rgba(254, 153, 0, 0.25);\n}\n.notifications-list .list-group-item.unread[data-v-15014480]:hover {\r\n    background: rgba(254, 222, 0, 0.1);\n}\r\n", ""]);

// exports
